//
// Theme customizations
//

$(function() {
  
  // filtering order form
  $(document).on('click', '.js-filter', function() {
    
    // state
    $('.js-filter').removeClass('is-current');
    $(this).addClass('is-current');
    
    // filter
    var filterString = $(this).data('filter');
    
    if (filterString == '*') {
      $('.js-filterable').removeClass('is-hidden');
    } else {
      $('.js-filterable').addClass('is-hidden');
      $('.js-filterable[data-filter="' + filterString + '"]').removeClass('is-hidden');
    }
  });
  
  // adjusting quantities
  $(document).on('keyup mouseup', '.js-quantity-check', function(){
    
    // DEBUG
    //console.log('changed qty');
    
    // if not wholesale customer, limit available quantities to on hand
    if ($('.js-wholesale-customer').length == 0) {
      var val = parseInt($(this).val());
      var max = parseInt($(this).attr('max'));
      
      // DEBUG
      /*
      console.log('val: ' + val);
      console.log('val type: ' + $.type(val));
      console.log('max: ' + max);
      console.log('max type: ' + $.type(max));
      */
      
      if (val > max) {
        
        // DEBUG
        //console.log('maxxed');
        $(this).val(max);
      }
    }
  });
});